var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUisses2Male(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 120,
    viewBox: "0 0 91 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4155_2577)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4155_2577",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 0H0.5V120H90.5V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4155_2577)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4155_2577",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 3,
    width: 93,
    height: 114
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 3H-0.5V117H91.5V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4155_2577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8703 40.98C20.8703 40.98 29.4403 44.95 46.7203 45.13C61.9803 45.29 70.9103 41.45 70.9103 41.45C70.9103 41.45 72.8803 48.83 72.5103 49.5C73.0203 53.5 73.0103 69 73.0103 69L72.5103 91L70.5103 108C70.5103 108 70.1003 109.23 61.0103 109C51.9203 108.77 52.5103 109 52.5103 109L51.0103 96.5L48.5103 84L46.4503 72.84L44.2603 72.46L40.0103 109.5C40.0103 109.5 42.5103 109 29.5103 110C17.5103 110 20.8803 110.5 20.8803 110.5L17.5103 90.5L17.0103 71L18.4103 54.92L19.5103 47.5L20.8903 40.98H20.8803H20.8703Z",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5802 -16.71C18.7902 -15.15 17.9302 -11.09 18.3202 -8.45996C18.8902 -4.59996 19.4002 -1.20996 20.0002 1.98004C21.6702 10.73 21.7402 10.63 22.5802 16.91C23.2702 22.06 23.1102 24.63 22.4102 27.57C21.7102 30.5 21.0502 33.25 20.8102 38.12C20.7502 39.31 20.7802 40.29 20.8102 40.93C18.3102 51.43 16.9002 65.29 17.3002 81.56C17.5802 92.79 19.0202 101.41 20.7802 109.59",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7603 109.84C40.6403 102.94 41.5103 95.9696 42.3403 88.9596C43.0003 83.4296 43.6303 77.9296 44.2503 72.4596C44.5503 72.5996 44.9303 72.7296 45.3703 72.7996C46.6503 72.9996 47.7003 72.5796 48.1803 72.3496",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.67 109.06C52.2 102.76 51.35 97.7296 50.65 94.2396C49.93 90.6496 49.31 88.4996 48.18 83.0196C47.3 78.7296 46.66 75.1996 46.27 72.8496",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3999 108.27C72.0799 98.3198 72.5599 89.9999 72.6399 83.9099C72.7399 77.0099 73.2599 79.4499 72.7499 62.5798C72.6399 58.9698 73.5299 53.9498 72.2999 47.3198C71.8299 44.7798 71.3299 42.6898 70.9499 41.2598C71.0299 39.5498 71.0499 36.9198 70.7299 33.7398C70.1599 28.1998 68.8699 26.3898 68.2299 22.1798C67.4999 17.3298 68.9399 16.7698 70.2799 8.70984C71.6699 0.289843 71.7699 -0.860157 71.3999 -5.88016C71.3199 -6.95016 71.7899 -9.37016 71.5999 -12.6102C71.4499 -15.1902 71.8499 -18.7302 71.4699 -20.4102",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.69 -52.9102C54.22 -49.3802 54.39 -46.5102 54.67 -44.7702C54.81 -43.9302 55.17 -43.1302 55.74 -42.4902C56.86 -41.2402 58.35 -40.4502 60.07 -39.9202C60.14 -39.9002 60.21 -39.8702 60.27 -39.8402L67.51 -36.6602C67.56 -36.6402 67.62 -36.6102 67.67 -36.6002C72.78 -34.8702 74.38 -34.9902 76.6 -33.8202C81.35 -31.3102 83.73 -22.3102 83.73 -16.3102C83.73 -15.1002 83.65 -15.1302 82.08 -5.76015C81.23 -0.670155 80.39 4.39984 80.06 6.69984C78.75 15.8998 79.8 22.6298 80.23 28.0798C80.84 35.7098 80.72 46.9798 77.2 62.0898C77.58 66.2098 76.89 69.5298 77.03 71.8498C77.2 74.5398 76.06 76.4098 75.85 76.8998C74.56 79.9498 74.51 80.1298 73.16 81.1898",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.77 -52.9102C36.24 -49.3802 36.07 -46.5102 35.79 -44.7702C35.65 -43.9302 35.29 -43.1302 34.72 -42.4902C33.6 -41.2402 32.11 -40.4502 30.39 -39.9202C30.32 -39.9002 30.25 -39.8702 30.19 -39.8402L22.95 -36.6602C22.9 -36.6402 22.84 -36.6102 22.79 -36.6002C17.92 -34.9502 15.09 -34.2502 13.86 -33.8202C8.88004 -32.0802 7.46005 -23.0002 7.11005 -20.7802C6.86005 -19.1702 6.69005 -17.1102 8.38005 -5.76015C9.54005 1.99985 9.96004 3.31984 10.4 6.69984C11.6 15.7998 10.7 22.3598 10.32 26.9598C9.70004 34.6298 9.79005 46.0898 13.25 62.0898C12.87 66.2098 13.56 69.5298 13.42 71.8498C13.25 74.5398 14.39 76.4098 14.6 76.8998C15.89 79.9498 15.94 80.1298 17.29 81.1898",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5698 25.1099C46.3198 24.3599 47.5298 24.3599 48.2898 25.1099",
    stroke: "#2E2E2E",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21017 63.71C5.99017 78.72 6.29017 86.86 10.2602 100.92",
    stroke: "#2E2E2E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.48 100.92C81.56 86.8098 82.08 78.6498 79.61 63.7598",
    stroke: "#2E2E2E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8803 49.8901C45.8803 49.8901 47.6003 70.1901 44.2603 72.4701",
    stroke: "#2E2E2E",
    strokeWidth: 0.23,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 42.1899C32.9002 46.1599 52.3402 49.7599 71.1302 42.3299L72.1502 47.0499C56.7202 53.2299 39.5602 52.3699 19.4302 47.7099L20.4902 42.1899H20.5002Z",
    fill: "#2E2E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0803 45.3498C57.0803 45.3498 58.9403 48.1198 58.2903 51.4098L61.1903 50.4798C61.1903 50.4798 62.4603 46.6298 60.5803 44.7598L57.0703 45.3398L57.0803 45.3498Z",
    fill: "#747474"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1502 45.36C37.1502 45.36 35.2902 48.39 35.9402 51.4L33.0402 50.55C33.0402 50.55 32.1602 46.5 34.0402 44.79L37.1502 45.36Z",
    fill: "#747474"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4804 42.47C23.4804 42.47 22.2104 46.49 22.6504 49.89L20.6804 48.93C20.6804 48.93 20.1004 43.66 21.3804 41.73L23.4804 42.47Z",
    fill: "#747474"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6104 43.0501C67.6104 43.0501 68.7903 45.9101 68.3803 49.3101L70.2204 48.3501C70.2204 48.3501 70.9904 44.2801 69.8004 42.3501L67.6104 43.0501Z",
    fill: "#747474"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 46.79L49.3 46.86C49.6 46.86 49.57 47.3 49.58 47.55L49.71 50.42C49.72 50.68 49.75 51.16 49.44 51.16L44.6 51.27",
    stroke: "white",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2402 49.0701C49.2402 49.0701 50.5302 49.6201 51.1002 48.8101",
    stroke: "white",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1704 49.2201C53.3305 49.2201 53.4604 49.0903 53.4604 48.9301C53.4604 48.77 53.3305 48.6401 53.1704 48.6401C53.0102 48.6401 52.8804 48.77 52.8804 48.9301C52.8804 49.0903 53.0102 49.2201 53.1704 49.2201Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1201 49.3598C47.2802 49.3598 47.4101 49.2299 47.4101 49.0698C47.4101 48.9096 47.2802 48.7798 47.1201 48.7798C46.9599 48.7798 46.8301 48.9096 46.8301 49.0698C46.8301 49.2299 46.9599 49.3598 47.1201 49.3598Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.52 48.85C43.6801 48.85 43.81 48.7202 43.81 48.56C43.81 48.3999 43.6801 48.27 43.52 48.27C43.3598 48.27 43.23 48.3999 43.23 48.56C43.23 48.7202 43.3598 48.85 43.52 48.85Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 48.9301C56.4101 48.9301 56.54 48.8003 56.54 48.6401C56.54 48.4799 56.4101 48.3501 56.25 48.3501C56.0898 48.3501 55.96 48.4799 55.96 48.6401C55.96 48.8003 56.0898 48.9301 56.25 48.9301Z",
    fill: "#231F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.88 67.8899C25.61 74.8399 25.91 81.9699 26.05 88.9999C26.35 96.0399 26.68 103.12 27.86 110.08H27.84C26.52 103.14 26.14 96.0499 25.91 88.9999C25.82 81.9799 25.52 74.7699 26.89 67.8799L26.88 67.8899Z",
    fill: "#2E2E2E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5598 109.03C66.9298 95.0301 67.5198 80.9301 66.9498 66.8701H66.9598C67.7598 80.9201 67.0198 95.0801 65.5498 109.03H65.5598Z",
    fill: "#2E2E2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.57 48.6401C22.59 53.4101 20.98 58.3901 17.71 62.0701C20.75 58.1701 22.51 53.4001 23.57 48.6401Z",
    fill: "#2E2E2E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9502 49.6802C70.0802 52.9202 71.8402 57.4602 72.7602 60.6902C71.5402 57.5602 70.0002 52.8902 68.9502 49.6802Z",
    fill: "#2E2E2E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4155_2577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 120,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUisses2Male);
export default __webpack_public_path__ + "static/media/сuisses-2-male.383bce8fba3079fca8fc3d26d506a3bd.svg";
export { ForwardRef as ReactComponent };